import PropTypes from 'prop-types';
import React from 'react';
import TvcIssuesListItem from './tvcIssuesListItem';
const TvcIssuesIssueListPanel = _ref => {
  let _ref$selectedCheck = _ref.selectedCheck,
    selectedCheck = _ref$selectedCheck === void 0 ? null : _ref$selectedCheck,
    listHeaderCount = _ref.listHeaderCount,
    listItemsVisible = _ref.listItemsVisible,
    rowKey = _ref.rowKey,
    animatingOutKeys = _ref.animatingOutKeys,
    _ref$expandedStableRo = _ref.expandedStableRowKey,
    expandedStableRowKey = _ref$expandedStableRo === void 0 ? null : _ref$expandedStableRo,
    onListRowToggle = _ref.onListRowToggle,
    onRestoreSucceeded = _ref.onRestoreSucceeded,
    _onRowExitAnimationEnd = _ref.onRowExitAnimationEnd;
  return /*#__PURE__*/React.createElement("div", {
    className: "tvc-issues-section__list"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tvc-issues-section__list-header"
  }, selectedCheck ? "".concat(selectedCheck.assetType, ": ").concat(selectedCheck.errorType, " (").concat(listHeaderCount, ")") : 'Select a check to view items'), /*#__PURE__*/React.createElement("ul", {
    className: "tvc-issues-section__list-items"
  }, listItemsVisible.map((item, index) => {
    const stableKey = rowKey(item);
    const isAnimatingOut = animatingOutKeys.has(stableKey);
    return /*#__PURE__*/React.createElement(TvcIssuesListItem, {
      key: stableKey,
      item: item,
      listIndex: index,
      stableRowKey: stableKey,
      isAnimatingOut: isAnimatingOut,
      isOpen: expandedStableRowKey === stableKey && !isAnimatingOut,
      onToggle: () => onListRowToggle(stableKey),
      onRestoreSucceeded: onRestoreSucceeded,
      onRowExitAnimationEnd: () => _onRowExitAnimationEnd(stableKey)
    });
  })));
};
const selectedCheckShape = PropTypes.shape({
  assetType: PropTypes.string.isRequired,
  errorType: PropTypes.string.isRequired
});
TvcIssuesIssueListPanel.propTypes = {
  selectedCheck: selectedCheckShape,
  listHeaderCount: PropTypes.number.isRequired,
  listItemsVisible: PropTypes.arrayOf(PropTypes.shape({
    formID: PropTypes.string,
    errorType: PropTypes.string,
    rowData: PropTypes.shape({
      rowTitle: PropTypes.string
    }),
    rowTitle: PropTypes.string,
    errorDetails: PropTypes.string
  })).isRequired,
  rowKey: PropTypes.func.isRequired,
  animatingOutKeys: PropTypes.instanceOf(Set).isRequired,
  expandedStableRowKey: PropTypes.string,
  onListRowToggle: PropTypes.func.isRequired,
  onRestoreSucceeded: PropTypes.func.isRequired,
  onRowExitAnimationEnd: PropTypes.func.isRequired
};
export default TvcIssuesIssueListPanel;